import React from "react";
import { Route, Redirect } from "react-router-dom";

export const ProtectedRoute = ({
  component: Component,
  allowedRoles = ["SystemAdmin"],
  readOnly = false,
  ...rest
}) => {
  const normalizeRole = role => String(role || "").trim().toLowerCase().replace(/\s+/g, "");
  const currentRole = normalizeRole(localStorage.getItem("role"));
  const canAccess = allowedRoles.some(role => normalizeRole(role) === currentRole);

  return (
    <Route
      {...rest}
      render={props => {
          if(canAccess){

              return <Component key={props.match.params.id} readOnly={readOnly} {...props} />;
            }else{
                return <Redirect to='/404'/>
            }

      }}
    />
  );
};
